import React from 'react';
import classNames from 'classnames';
import AntSwitch from 'antd/lib/switch';
import './style';

class Switch extends React.Component {
  render() {
    const { className, children, ...rest } = this.props;
    const computedClassName = classNames('bsa-switch', className);
    return (
      <AntSwitch className={computedClassName} {...rest}>
        {children}
      </AntSwitch>
    );
  }
}

Switch.defaultProps = AntSwitch.defaultProps;
Switch.propTypes = AntSwitch.propTypes;
export default Switch;
